import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RolePermissionService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * get role options by userType
   * @param param userType
   */
  getRoleOptions(userType: string): Observable<any>{
    const url = `${environment.authUrl}/role/roleOption/${userType}`;
    return this.http.get(url);
  }

  /**
   * get all permission
   */
  getAllPermission(): Promise<any>{
    const url = `${environment.authUrl}/permission`;
    return this.http.get(url).toPromise();
  }

  /**
   * get permission by role code
   * @param roleCode
   */
  getpermissionByRoleCode(roleCode: number): Observable<any>{
    const url = `${environment.authUrl}/role/rolePermission/${roleCode}`;
    return this.http.get(url);
  }

  /**
   * modify role permission
   * @param roleCode
   * @param updateObj
   */
  modifyRolePermission(roleCode: number, currentUser: string, updateObj: any[]): Observable<any>{
    const url = `${environment.authUrl}/permission/${roleCode}/${currentUser}`;
    return this.http.post(url, updateObj);
  }

  /**
   * get All roles
   */
  getRoles(params: any): Observable<any>{
    const url = `${environment.authUrl}/role/roles`;
    return this.http.post(url, params);
  }

  /**
   * insert Object
   * @param addObj
   */
  saveRole(addObj: any): Observable<any>{
    const url = `${environment.authUrl}/role`;
    return this.http.post(url, addObj);
  }
}
